import { useLazyQuery, useMutation } from "@apollo/client/react"; 
import { Box, Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import { CheckboxGroupInput } from '../../../../../components/checkboxInput/CheckboxGroupInput';
import { SwitchInput } from '../../../../../components/switchInput/SwitchInput';
import GET_ESQUEMA_CONEXIONES, { adaptEsquemaConexiones } from '../../../../../data/graphQL/queries/GestionAsistencial/conexionDiasByIdEvaluacion';
import toast from 'react-hot-toast';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import GET_HISTORIAL_CONEXIONES, { adaptHistorialConexionesArray, groupEvaluations } from '../../../../../data/graphQL/queries/GestionAsistencial/getEsquemaHistoricoByIdEvaluacion';
import { CREATE_ESQUEMA_CONEXION } from '../../../../../data/graphQL/mutations/GestionAsistencial/createEsquemaConexion ';

const idUsuarioLoggeado = sessionStorage.getItem('idUsuario');

export const EsquemaConexion = ({
  allowedWrite,
  idEvaluacionSelected,
  dias,
  poseeEsquema,
  setPoseeEsquema,
  esquema,
  setEsquema
}) => {
  const [poseeEsquemaAux, setPoseeEsquemaAux] = useState(poseeEsquema);
  const [openModal, setOpenModal] = useState(false);
  const [esquemaAux, setEsquemaAux] = useState([]);

  const {
    columns,
    rows,
    totalCount,
    loadingHistorial,
    getHistorialConexiones
  } = useGetHistorial(idEvaluacionSelected, dias);

  const [getEsquemaConexiones, { data: dataEsquemaConexiones }] = useLazyQuery(GET_ESQUEMA_CONEXIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataEsquemaConexiones) return;
    const adaptedEsquema = adaptEsquemaConexiones(dataEsquemaConexiones?.conexionDiasByIdEvaluacion || []);
    setPoseeEsquemaAux(adaptedEsquema?.length > 0 || poseeEsquema);
    setEsquema(adaptedEsquema);
    setEsquemaAux(adaptedEsquema);
  }, [dataEsquemaConexiones]);


  const [saveEsquema] = useMutation(CREATE_ESQUEMA_CONEXION, {
    variables: {
      idEvaluacion: idEvaluacionSelected,
      idUsuario: parseInt(idUsuarioLoggeado),
      idsDias: esquemaAux
    },
    onCompleted: () => {
      getEsquemaConexiones({ variables: { idEvaluacion: idEvaluacionSelected } });
    }
  });

  useEffect(() => {
    if (!idEvaluacionSelected) return;
    getEsquemaConexiones({ variables: { idEvaluacion: idEvaluacionSelected } });
    setPoseeEsquemaAux(poseeEsquema);
  }, [poseeEsquema, idEvaluacionSelected]);

  const onChangePoseeEsquema = (event) => {
    const { checked } = event.target;
    setPoseeEsquemaAux(checked);
    if (!checked) {
      setEsquemaAux([]);
    }
  };

  const onChangeEsquema = (_, value) => {
    setEsquemaAux(value);
  };

  const handleCloseModal = () => setOpenModal(false);
  const handleOpenModal = () => setOpenModal(true);

  const handleConsultar = () => {
    handleOpenModal();
    getHistorialConexiones({ variables: { idEvaluacion: idEvaluacionSelected } });
  };

  const isValid = () => {
    const errorMessages = [];

    if (poseeEsquemaAux && !esquemaAux?.length) {
      errorMessages.push('Debe elegir al menos un día para el esquema.\n');
    }


    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  };


  const handleSave = () => {
    if (isValid()) {
      toast.promise(saveEsquema(), {
        loading: 'Guardando...',
        success: 'Nuevo esquema guardado.',
        error: 'Ocurrió un error al guardar el nuevo esquema.'
      });
    }
  };

  return (
    <div className='generic-tab-container'>
      <Grid container size={{ xs: 12 }}>
      <Grid container item spacing={3} size={{ xs: 12 }}>
        <Grid size={{ xs: 12 }}>
          <div className='generic-header-tab-content-with-buttons'>
            <strong>Esquema de Conexión</strong>
            <div className='button-save-geo-data'>
              <CustomButton
                onClick={handleConsultar}
                label='Consultar'
                variant='outlined' />

              <CustomButton
                sx={{ marginLeft: '20px' }}
                onClick={handleSave}
                label='Guardar'
                disabled={!allowedWrite}
                variant='outlined' />

            </div>
          </div>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span className={'span-row'}>Posee esquema</span>
            <SwitchInput
              onChange={onChangePoseeEsquema}
              checked={poseeEsquemaAux}
              name='poseeEsquemaAux'
              disabled={!allowedWrite || poseeEsquema} />

          </Box>
        </Grid>
      </Grid>
      {poseeEsquemaAux && <Grid size={{ xs: 12 }}>
        <CheckboxGroupInput
          options={dias}
          onChange={onChangeEsquema}
          selectAllOption={true}
          value={esquemaAux}
          fullWidth />
      </Grid>}
      </Grid>
      <CustomDialog
        open={openModal}
        title='Esquema de conexiones'
        onCancel={handleCloseModal}
        cancelText='Cerrar'
        fullWidth
        maxWidth='md'>

        <DataGridGenerico
          toolbar={false}
          columns={columns}
          rows={rows}
          totalCount={totalCount}
          loading={loadingHistorial} />

      </CustomDialog>
    </div>);

};

const useGetHistorial = (idEvaluacion, diasNombre) => {

  const [rows, setRows] = useState([]);

  const baseColumns = [
    {
      headerName: 'Conecta los días',
      field: 'dias',
      flex: 2,
      valueGetter: (dias) => {
        const diasLabels = dias.
          map((diaId) => diasNombre.find((dia) => dia.value === diaId)?.label).
          filter((x) => x).
          join(', ');
        return diasLabels;
      }
    },
    {
      headerName: 'Usuario',
      field: 'usuario',
      flex: 1
    },
    {
      headerName: 'Fecha de cambio',
      field: 'fechaAlta',
      type: 'date',
      time: true,
      flex: 1
    }];


  const [getHistorialConexiones, { data: dataHistorialConexiones, loading: loadingHistorial }] = useLazyQuery(GET_HISTORIAL_CONEXIONES, {
    fetchPolicy: 'no-cache',
    variables: { idEvaluacion }
  });

  useEffect(() => {
    if (!dataHistorialConexiones) return;
    const adaptedHistoral = adaptHistorialConexionesArray(dataHistorialConexiones?.esquemaHistoricoByIdEvaluacion);
    const historialAgrupado = groupEvaluations(adaptedHistoral);
    setRows(historialAgrupado);
  }, [dataHistorialConexiones]);


  const columns = useMemo(() => generateColumnsDefaultConfiguration(baseColumns), [baseColumns]);
  const totalCount = useMemo(() => rows?.length || 0, [rows]);

  return {
    rows,
    columns,
    totalCount,
    loadingHistorial,
    getHistorialConexiones
  };
};